import { getEditorialRequestRevision } from 'app/config/editorialRequestSession.config';
import axios from 'axios';

export function editorialRequest(action, method, ...args) {
  if (!['read', 'write'].includes(action) || !['get', 'post', 'put', 'patch', 'delete'].includes(method)) throw new Error('INVALID_EDITORIAL_REQUEST');
  const configIndex = ['get', 'delete'].includes(method) ? 1 : 2;
  args[configIndex] = { ...args[configIndex], editorialAction: action, editorialRevision: getEditorialRequestRevision() };
  return axios[method](...args);
}
